import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserAnalystSettings, setUserAnalystSettings} from 'src/openapi/admin/apis/UsersAnalystSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {AnalystCommentarySettings} from 'src/openapi/admin/models/AnalystCommentarySettings';

type Props = {
    userId: number,
};

export const useAnalystSettings = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getUserAnalystSettings({userId}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        analystCommentarySettings: AnalystCommentarySettings,
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        setUserAnalystSettings({
            userId,
            userAnalystSettingsSaveRequest: {...analystCommentarySettings, reason: options?.reason},
        }, {signal}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            commentaryOnDeals: false,
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
